import { defineClassComponent } from './hooks'
import { h, Ref, ref } from '@vue/composition-api'

const _portNodes: any[] = []
let portNodes!: Ref<any[]>

export const Port = defineClassComponent(
  () =>
    class {
      constructor() {
        portNodes = this.portNodes
      }

      portNodes = ref<any[]>(_portNodes)

      render = () => h('div', this.portNodes.value)
    },
)

export function addPortNode(node: any) {
  const __PORT_KEY__ = Date.now()
  Object.defineProperty(node, '__PORT_KEY__', {
    value: __PORT_KEY__,
  })
  if (portNodes?.value) {
    portNodes.value.push(node)
  } else {
    _portNodes.push(node)
  }
  return () =>
    portNodes.value.splice(
      portNodes.value.findIndex(node => node.__PORT_KEY__ === __PORT_KEY__),
      1,
    )
}
